import React from 'react'
import Label from "components/general/Label"
import { findArray } from 'helpers/utils';
import { createColumnsIntermediate } from 'components/sports/swm/helper/SwmHelpers'
import { ColumnStartOrder, ColumnRank, ColumnName, ColumnNoc, ColumnResult, ColumnDifference, ColumnExpander, ColumnRecords } from "components/common/TableColumns"

export function TableColumnsRelayStart() {

    return (
        [
            ColumnStartOrder({ disableSort: true, label: "HeaderLane" }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumnsRelayLive(columnsAdded, isLess4) {
    let columnsExt = createColumnsIntermediate(columnsAdded, isLess4);
    return (
        [
            ColumnRank({ disableSort: true }),
            ColumnStartOrder({ disableSort: true, label: "HeaderLane" }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),

            ...columnsExt,

            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumnsRaceRelayFinish() {
    return (
        [
            ColumnRank({ disableSort: true }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnResult({ disableSort: true, label: "HeaderTime" }),
            ColumnDifference({ disableSort: true }),
            ColumnRecords({}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumnsSummary() {
    return (
        [
            ColumnRankSum({ disableSort: true }),
            ColumnHeat({ disableSort: true }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnResult({ disableSort: true, label: "HeaderTime" }),
            ColumnDifference({ disableSort: true }),
            ColumnQualification({ disableSort: true })
        ]
    )
}

export function ColumnQualification({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-5',
}) {
    return (
        {
            accessor: 'qualMark',// accessor is the "key" in the data 
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'QualMark',
        }
    )
}

export function ColumnRankSum({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderRank'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'rank',// accessor is the "key" in the data 
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'rankSum',
        }
    )
}

export function ColumnHeat({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderHeat'
}) {
    return (
        {
            Header: <Label data={label} />,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Heat',
            Cell: (props) => {
                let value = findArray(props.cell.row.original.extendedResults, { er_code: ['UNIT'] }).er_value
                return value
            }
        }
    )
}

